import { get } from 'lodash'
 
class StripeSubscriptionItem {
    static id = stripeSubscriptionItem => get(stripeSubscriptionItem, 'id', '')
}

export default StripeSubscriptionItem;